export const PHASE5_REPORT_TABS = Object.freeze([
  { key: 'intro', visibilityKey: null, label: 'Process Intro', testId: 'tab-intro-process' },
  { key: 'data-quality', visibilityKey: null, label: '⚠️ Data Quality', testId: 'tab-data-quality' },
  { key: 'sqis', visibilityKey: null, label: '14 Points SQIS', testId: 'tab-sqis' },
  { key: 'why', visibilityKey: null, label: '"Why" (Patterns & Contributing Themes)', testId: 'tab-why-patterns' },
  { key: 'next', visibilityKey: null, label: 'Next Steps', testId: 'tab-next-steps' },
  { key: 'nexus', visibilityKey: null, label: 'Nexus', testId: 'tab-nexus' },
  { key: 'client-summary', visibilityKey: null, label: 'Client Synthesis', testId: 'tab-client-summary' },
  { key: 'custom_reports', visibilityKey: 'custom_reports', label: 'Custom Analysis', testId: 'tab-custom-reports' },
  { key: 'helpful-resources', visibilityKey: 'helpful_resources', label: 'Reflection Resources', testId: 'tab-helpful-resources' },
  { key: 'research', visibilityKey: 'research_resources', label: 'Research Resources', testId: 'tab-research' },
]);

export const indexedAiReportsWithoutClientSummary = (reports = []) =>
  reports
    .map((report, index) => ({ report, index }))
    .filter(({ report }) => ![
      'ai_summary',
      'apa_case_parallels',
      'research_framework_synthesis',
      'developmental_ecological_cultural',
      'ask_buddy',
    ].includes(report?.report_type));

export const findClientSummaryReport = (reports = []) => {
  const index = reports.map(report => (
    report?.report_type === 'ai_summary'
    && typeof report?.content === 'string'
    && report.content.trim().length > 0
  )).lastIndexOf(true);
  return index < 0 ? null : { report: reports[index], index };
};

// Custom Report ownership is explicit at creation time.  The custom_reports
// storage array also contains legacy Research records, so array membership is
// not an ownership discriminator.
export const actualCustomReports = (reports = []) => {
  const seen = new Set();
  return reports.filter((report, index) => {
    if (report?.is_custom !== true) return false;
    const stableId = report.id || report._id || [
      report.report_type || 'custom_report',
      report.generated_at || report.created_at || `index:${index}`,
      report.psychologist_id || '',
    ].join(':');
    if (seen.has(stableId)) return false;
    seen.add(stableId);
    return true;
  });
};

export const researchReportsForType = (phase5Data = {}, reportType) => {
  const sources = reportType === 'developmental_ecological_cultural'
    ? [...(phase5Data.ai_reports || []), ...(phase5Data.custom_reports || [])]
    : (phase5Data.ai_reports || []);
  return sources.filter(report => report?.report_type === reportType);
};

export const normalizePhase5ReportTab = (tab) => (
  tab === 'assistants' ? 'custom_reports' :
  tab === 'narrative_probe' || tab === 'narrative-probe' ? 'nexus' : tab
);

export const visiblePhase5ReportTabs = (reportVisibility = {}) =>
  PHASE5_REPORT_TABS.filter(({ visibilityKey }) => {
    if (visibilityKey === null) return true;
    if (visibilityKey === 'helpful_resources') {
      return reportVisibility.book_recommendations !== false || reportVisibility.movie_recommendations !== false || reportVisibility.music_recommendations !== false;
    }
    if (visibilityKey === 'research_resources') {
      return reportVisibility.apa_case_parallels !== false
        || reportVisibility.research_framework_synthesis !== false
        || reportVisibility.developmental_ecological_cultural !== false;
    }
    return reportVisibility[visibilityKey] !== false;
  });

export const recommendationDependenciesReady = (phase5Data = {}) =>
  Boolean(phase5Data?.why_patterns?.content?.trim() && phase5Data?.next_steps?.content?.trim());
